import {
  Checkbox,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";

interface Props {
  item: any;
  handleFormItem: any;
  options: any;
  disabled?: any;
  value: any;
  allowMultiple?: any;
}

export default function MultipleChoiceInput(props: Props) {
  const {
    handleFormItem,
    item,
    options = [],
    disabled = false,
    value,
    allowMultiple = false,
  } = props;

  const handleOnSelect = (selectedItem: any) => {
    handleFormItem(selectedItem, item.chave);
  };

  if (allowMultiple) {
    return (
      <div className="flex flex-col gap-1">
        {options
          .map((option: any) => option.replace(/[\u200B-\u200D\uFEFF]/g, ""))
          .map((option: any, index: number) => (
            <label
              key={`item-${item.chave}-${index}`}
              htmlFor={`${item.chave}-${index}`}
              className="flex cursor-pointer items-start gap-2 rounded-lg px-1 py-1.5 hover:bg-primaryLight/60"
            >
              <Checkbox
                id={`${item.chave}-${index}`}
                className="!p-0"
                sx={{
                  padding: 0,
                  "&.Mui-checked": {
                    color: "#009556",
                  },
                }}
                onChange={() => {
                  if (disabled) {
                    return;
                  }
                  if (
                    value &&
                    !!value.find((val: any) => val.name === option)
                  ) {
                    const updatedValue = [...value].filter(
                      (val) => val.name !== option
                    );
                    handleOnSelect(updatedValue);
                  } else {
                    const updatedValue = [
                      ...(value ? [...value] : []),
                      { name: option },
                    ];
                    handleOnSelect(updatedValue);
                  }
                }}
                checked={
                  value && !!value.find((val: any) => val.name === option)
                    ? true
                    : false
                }
                disabled={disabled || options.length === 0}
              />
              <span className="pt-0.5 text-sm leading-snug text-gray">
                {option}
              </span>
            </label>
          ))}
      </div>
    );
  }

  return (
    <FormControl>
      <RadioGroup
        value={value ?? ""}
        onChange={(e) => handleOnSelect(e.target.value)}
      >
        {options
          .map((option: any) => option.replace(/[\u200B-\u200D\uFEFF]/g, ""))
          .map((option: any, index: number) => {
            return (
              <FormControlLabel
                key={`item-${item.chave}-${index}`}
                value={option}
                className="!mx-0 rounded-lg px-1 hover:bg-primaryLight/60"
                control={
                  <Radio
                    id={`${item.chave}-${index}`}
                    sx={{
                      "&.Mui-checked": {
                        color: "#009556",
                      },
                    }}
                    checked={value === option}
                    disabled={disabled}
                  />
                }
                label={option}
              />
            );
          })}
      </RadioGroup>
    </FormControl>
  );
}
